import { useMutation } from '@tanstack/react-query'
import { storageService } from '../../service/domain/_service.config'

export function useUploadProfilePhoto(userID: string) {
  return useMutation({
    mutationFn: (file: File) => storageService.uploadProfileImage(file, userID),
  })
}
